var a=(a,e,r=e)=>(a.splice(e,r-e+1),a);export{a as default};